export const paths = {
	// Core paths
	root: '/',
	home: '/home',
	logout: '/logout',
	login: '/login',
	changePassword: '/change-password',
	privacy: '/privacy',
	terms: '/terms',
	/** Public marketing page for the applicant iOS app (ASC Marketing URL). */
	mobileApp: '/app',
	redirect: '/redirect',
	registerApplicant: '/register',
	registerMember: '/board-registration',

	// Applicant paths
	apply: '/apply',
	createApplication: '/apply/:applicationType',
	updateApplication: '/apply/:applicationType/:applicationID',
	reviewApp: '/review/:id',
	rsvp: '/interviews/rsvp',
	requests: '/requests/:token',
	unsubscribe: '/unsubscribe/:encID',

	// Member paths
	members: '/members',
	memberDash: '/members/dashboard',
	contactCenter: '/members/contact',
	allMembers: '/members/all',
	viewMember: '/members/view/:id',
	newMember: '/members/new',
	editMember: '/members/edit/:id',

	// Member Tools
	siteSettings: '/members/settings',
	financeCenter: '/members/finances',
	cycleExpenses: '/members/cycle-expenses',
	manualUpload: '/members/manual-upload',

	// Request Management Paths
	allRequests: '/members/requests',
	editRequest: '/members/requests/edit/:id',
	newRequest: '/members/requests/new',

	// Email Management paths
	inbox: '/members/email/mailbox',
	viewEmail: '/members/email/view/:id',
	composeEmail: '/members/email/new',
	chatInbox: '/members/chat',

	// Applicant Management paths
	applicants: '/applicants',
	allApplicants: '/applicants/all',
	viewApplicant: '/applicants/view/:id',
	editApplicant: '/applicants/edit/:id',
	newApplicant: '/applicants/new',

	// Application Management paths
	applications: '/applications',
	allApps: '/applications/all',
	viewApp: '/applications/view/:id',
	exportApp: '/applications/export/:id',
	archives: '/applications/archives',
	completedApps: '/applications/completed',
	eligibleApps: '/applications/eligible',
	invitedApps: '/applications/invited',
	awardedApps: '/applications/awarded',
	deletedApps: '/applications/deleted',
	rejectedApps: '/applications/rejected',
	incompleteApps: '/applications/incomplete',
	completedAppsInYear: '/applications/:year/completed',
	eligibleAppsInYear: '/applications/:year/eligible',
	invitedAppsInYear: '/applications/:year/invited',
	awardedAppsInYear: '/applications/:year/awarded',
	deletedAppsInYear: '/applications/:year/deleted',
	rejectedAppsInYear: '/applications/:year/rejected',
	incompleteAppsInYear: '/applications/:year/incomplete',
	newApps: '/applications/newApplicants',
	returningApps: '/applications/returningGrants',
	scholarshipApps: '/applications/scholarshipRecipients',
	newAppsInYear: '/applications/:year/newApplicants',
	returningAppsInYear: '/applications/:year/returningGrants',
	scholarshipAppsInYear: '/applications/:year/scholarshipRecipients',
	allAppsInYear: '/applications/:year/all',

	// Interview paths
	waitingRoom: '/interviews/waiting-room/:interviewId',
	interviewRoom: '/interviews/interview-room/:interviewId',
	deliberationRoom: '/interviews/deliberation-room',
	scheduling: '/members/interviews/scheduling',
	interviewDash: '/members/interviews/dashboard',

	// Error paths
	notFound: '/not-found',
	caAccessDenied: '/access-denied',
	adminAccessDenied: '/members/access-denied',

	// Catch-all path (must be last)
	caRoot: '*',
} as const;

export type PathKey = keyof typeof paths;
export type PathValue = (typeof paths)[PathKey];
